import React, { type FC } from "react";
import NiceModal, {
  type NiceModalHocProps,
  useModal
} from "@ebay/nice-modal-react";
import KC_Modal_2 from "../../../../designsystem/KC_Modal/KC_Modal_2";
import KC_Heading3 from "../../../../designsystem/typography/KC-Heading/KC_Heading3";
import KC_Button, {
  KC_ButtonSize
} from "../../../../designsystem/KC_Button/KC_Button";
import { KC_Weights } from "../../../../designsystem/ds_commons";
import { tt } from "../../../../utils/i18n/i18n";
import KC_UIText from "../../../../designsystem/typography/KC_UIText/KC_UIText";
import { JETPACK_CONFIG } from "../../../../utils/routes/routes";
import "./styles.scss";
import { buildPathWithTrackingId } from "../../../../utils/routing/routingUtils";
import ManagedAccount from "@tootsweet/model/entities/ManagedAccount";

interface Props {
  endDate: string;
  history: any;
  isImmediate?: boolean;
  accountToDisplay: ManagedAccount;
}

const UnsubscribeSuccessModal: FC<Props & NiceModalHocProps> =
  NiceModal.create<Props>((props) => {
    const modal = useModal();

    const handleClose = () => {
      props.history.push(
        buildPathWithTrackingId(
          JETPACK_CONFIG,
          props.accountToDisplay.trackingID
        )
      );
      modal.resolve(true);
      void modal.hide();
    };

    return (
      <KC_Modal_2
        id="unsubscribe-success-modal"
        isOpen={modal.visible}
        onClose={handleClose}
        hideCloseButton={true}
        header={
          <div className={"w-100 py-2 px-3"}>
            <KC_Heading3 text={tt("unsubscribe_success_title")} />
          </div>
        }
        footer={
          <div className="d-flex flex-grow-1 align-items-center justify-content-center">
            <KC_Button
              id="unsubscribe-success-confirm"
              isPrimary={true}
              onClick={handleClose}
              size={KC_ButtonSize.Large}
              text={tt("unsubscribe_back_home")}
              className="d-flex"
            />
          </div>
        }
      >
        <div className="p-4 text-center" style={{ minHeight: 100 }}>
          <KC_UIText
            weight={KC_Weights.reg}
            text={
              props.isImmediate
                ? tt("unsubscribe_immediately_success_message")
                : tt("unsubscribe_success_message", { endDate: props.endDate })
            }
          />
        </div>
      </KC_Modal_2>
    );
  });

export default UnsubscribeSuccessModal;
